var sw = require('js/lib/sw');

module.exports = function($fragment) {
  $fragment.swFindWithSelf('[data-sw-model-material-configurator-material-selector]').each(function() {
    var modelId = $(this).attr('data-sw-model-material-configurator-material-selector');
    var el = this;
    require(
      [
        'vue',
        'vuex',
        'rrViewComponents/Model/MaterialConfigurator/sw-model-material-configurator-module',
        'rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorMaterialSelectorComponent/tpl.model-material-configurator-material-selector-vue.mustache'
      ], function (vue, vuex, modelMaterialConfiguratorModule, tpl) {
        new vue({
        el: el,
        data: {
          modelId: modelId
        },
        delimiters: ["<%", "%>"],
        template: tpl.render(),
        store: modelMaterialConfiguratorModule,
        updated: function () {
          /**
           * In order to have mixpanel autohandling work
           * with vue we just call fragment loaded
           */
          this.$nextTick(function () {
            sw.trigger('sw-fragment-loaded', $(this.$el));
          });
        },
        computed: vuex.mapState({
          materialGroupOptions: function (state) {
            return state[this.modelId].materialGroupOptions;
          },
          hasMaterialGroupSelected: function (state) {
            return state[this.modelId].hasMaterialGroupSelected;
          },
          printableMaterialGroupsAndPrices: function(state) {
            return state[this.modelId].printableMaterialGroupsAndPrices;
          },
          hasNonPrintableMaterialGroups: function(state) {
            return state[this.modelId].nonPrintableMaterialGroups
              && state[this.modelId].nonPrintableMaterialGroups.length > 0;
          },
          nonPrintableMaterialGroups: function(state) {
            return state[this.modelId].nonPrintableMaterialGroups;
          },
          materialGroupChoiceName: function (state) {
            return state[this.modelId].materialGroupChoiceName;
          },
          
          isLoading: function(state) {
            return state[this.modelId].isLoading || false;
          },
          materialGroupChoiceNameGuidelineUrl: function(state) {
            return state[this.modelId].selectedMaterialGroupGuidelineUrl || null;
          }
        }),
        methods: {
          selectMaterialGroup: function (materialGroupId) {
            modelMaterialConfiguratorModule.dispatch('modelMaterialConfigurator/updateChoice', {
              modelId: this.modelId,
              hasMaterialGroupSelected: true,
              selectedMaterialGroupId: materialGroupId,
              selected: 'material'
            });
          },
          changeMaterialGroupChoice: function() {
            modelMaterialConfiguratorModule.dispatch('modelMaterialConfigurator/updateChoice', {
              modelId: this.modelId,
              hasMaterialGroupSelected: false,
              hasColorSelected: false,
              hasFinishSelected: false,
              selectedMaterialGroupId: null,
              selected: 'changeMaterial'
            });
          }
        }
      });
    });
  });
};
